<template>
	<div
		:class="['rating-box-badge', blockClassModifiers]"
		v-text="rating"
	></div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
	rating: string;
	theme?: 'bold' | 'normal';
}

const { rating, theme = 'bold' } = defineProps<Props>();

const blockClassModifiers = computed(() => ({
	[`rating-box-badge--${theme}`]: true,
}));
</script>
<style scoped lang="scss">
.rating-box-badge {
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: $font-family;
	color: $color-white;
	font-weight: $font-weight-semibold;
	font-size: $font-small-1;
	line-height: 2.7rem;
	border-radius: $border-radius-small;
	height: 4rem;
	min-width: 4rem;
	padding: 0.6rem 1rem;

	&--bold {
		background-color: $color-link;
	}

	&--normal {
		background-color: $color-border;
		color: $color-black;
		height: 4.4rem;
		min-width: 4.4rem;
	}

	@include media-query-up($breakpoint-small) {
		padding: 0.8rem 1.2rem;

		&--bold {
			font-size: $font-medium-2;
			height: 5.4rem;
			min-width: 5.4rem;
		}

		&--normal {
			font-size: $font-medium-3;
			height: 4.8rem;
			min-width: 4.8rem;
		}
	}

	@include media-query-up($breakpoint-large) {
		padding: 1.2rem 1.4rem;
		font-size: $font-medium-2;
		height: 5.4rem;
		min-width: 5.4rem;
	}
}
</style>
